export default [   //权限列表的数据集

    // ********前台权限
    {
        title:"任务管理",
        id:1,
        code:1000,
        check_all:false,
        options:[    //选项  options
           {
                id:2,
                code:1010,
                text:"发布任务",
           },
           {
                id:3,
                code:1020,
                text:"处理任务",
           },
           {
                id:4,
                code:1030,
                text:"终止任务",
           },
        ],
    },
    {
        title:"个人财务",
        id:5,
        code:1100,
        check_all:false,
        options:[    //选项  options
           {
                id:6,
                code:1110,
                text:"个人奖金",
           },
           {
                id:7,
                code:1120,
                text:"个人罚单",
           },
        ],
    },
    {
        title:"文档管理",
        id:8,
        code:1200,
        check_all:false,
        options:[],
    },
    {
        title:"BU管理",
        id:9,
        code:1300,
        check_all:false,
        options:[    //选项  options
           {
                id:10,
                code:1310,
                text:"BU与职员",
           },
           {
                id:11,
                code:1320,
                text:"BU资产",
           },
        ],
    },
    {
        title:"我的申请",
        id:12,
        code:1400,
        check_all:false,
        options:[],
    },
    {
        title:"审核管理",
        id:13,
        code:1500,
        check_all:false,
        options:[    //选项  options
           {
                id:14,
                code:1510,
                text:"任务审核",
           },
           {
                id:15,
                code:1520,
                text:"财务审核",
           },
           {
                id:16,
                code:1530,
                text:"人事审核",
           },
        ],
    },


    // ********后台权限
    {
        title:"管理员权限",
        id:17,
        code:2000,
        check_all:false,
        options:[],
    },
    {
        title:"基础设置",
        id:18,
        code:2100,
        check_all:false,
        options:[    //选项  options
           {
                id:19,
                code:2110,
                text:"快币设置",
           },
           {
                id:20,
                code:2120,
                text:"任务设置",
           },
           {
                id:21,
                code:2130,
                text:"非工作日设置",
           },
           {
                id:22,
                code:2140,
                text:"罚单设置",
           },
           {
                id:23,
                code:2150,
                text:"岗位设置",
           },
           {
                id:24,
                code:2160,
                text:"奖金职级设置",
           },
        //    {
        //         id:25,
        //         code:2170,
        //         text:"操作日志",
        //    },
        ],
    },
    {
        title:"职员管理",
        id:26,
        code:2200,
        check_all:false,
        options:[    //选项  options
           {
                id:27,
                code:2210,
                text:"BU人员",
           },
           {
                id:28,
                code:2220,
                text:"角色设置",
           },
        ],
    },
    {
        title:"资产管理",
        id:29,
        code:2300,
        check_all:false,
        options:[    //选项  options
           {
                id:30,
                code:2310,
                text:"预算充值",
           },
           {
                id:31,
                code:2320,
                text:"奖金充值",
           },
           {
                id:39,
                code:2350,
                text:"职级充值",
           },
           {
                id:33,
                code:2340,
                text:"充值记录",
           },
           {
                id:32,
                code:2330,
                text:"结算记录",
           },
        ],
    },
    {
        title:"文档管理",
        id:34,
        code:2400,
        check_all:false,
        options:[    //选项  options
           {
                id:35,
                code:2410,
                text:"文件浏览",
           },
           {
                id:36,
                code:2420,
                text:"文档模板",
           },
        ],
    },
    {
        title:"任务管理",
        id:37,
        code:2500,
        check_all:false,
        options:[    //选项  options
           {
                id:38,
                code:2510,
                text:"任务浏览",
           },
        ],
    },
]


// WEBPACK FOOTER //
// ./src/config/permission-config.js